module.exports = __webpack_public_path__ + "img/logo.556a5b64.jpg";